import React, { useContext } from "react";
import { Badge, Text, Link, Thumbnail, InlineStack, Box, Divider, BlockStack } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { baseHelper, imageHelper, statusHelper } from "lib/helpers";
import LineItemProperties from "app/orders/modules/generic/service/lineItemProperties";
import { useNavigate } from "react-router-dom";

const RejectedLineItems = (props) => {
  const { data = {}, lineItemArray = [], refundLineData = [], setRejectAmount } = props;
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();

  const amount = [];
  const vendorsSum = [];
  let countItems = 0;

  // refundLineData &&
  //   refundLineData.length &&
  //   refundLineData.forEach((dataLine) => {
  //     const { totalPrice = 0, line_item: itemLine = {} } = dataLine || {};
  //     const { vendor } = itemLine || {};
  //     vendorsSum.push(vendor);
  //     amount.push(totalPrice);
  //     countItems += 1;
  //     return [amount];
  //   });

  if (refundLineData && refundLineData.length) {
    refundLineData.forEach((dataLine) => {
      const { totalPrice = 0, line_item: itemLine = {} } = dataLine || {};
      const { vendor } = itemLine || {};
      vendorsSum.push(vendor);
      amount.push(totalPrice);
      countItems += 1;
      return [amount];
    });
  }

  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

  if (totalAmount) {
    setRejectAmount(totalAmount);
  }

  const lineItems =
    refundLineData &&
    refundLineData.length &&
    refundLineData.map((lineData, idx) => {
      const { line_item: itemLine = {}, line_item_id: shopifyLineItemId = "", totalPrice, totalQuantity } =
        lineData || {};
      const { sku = "", title = "" } = itemLine || {};

      const getItem = lineItemArray.find((item) => item.shopifyLineItemId === shopifyLineItemId);
      const {
        fulfillmentType = "",
        image = "",
        isAutoExpiry,
        isAutoReject,
        isProductDeleted,
        isRefund,
        moneyFormat: lineMoneyFormat,
        productId,
        properties,
        vendor,
        vendorId,
      } = getItem || {};

      const lineItemKey = `lineItem${idx}`;
      const lineImage = imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

      const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;
      const autoStatus = isRefund && isAutoReject ? constant.AUTO_REJECT : isAutoExpiry && constant.NO_SHOW;
      const status = statusHelper.getBadgeStatus(autoStatus || constant.REJECTED);
      const isServiceLineItem = baseHelper.isServiceLineItem(fulfillmentType, properties);
      const productURL = isServiceLineItem ? `/products/service/edit/${productId}` : `/products/edit/${productId}`;

      const lineItemName = <div className="productName">{title}</div>;

      return (
        <div key={lineItemKey} className="fulfilled-Secn">
          <Box padding="400">
            <InlineStack wrap={false} align="space-between">
              <InlineStack gap="400">
                <Thumbnail size="large" source={lineImage} alt={title} />
                <BlockStack inlineAlign="start" gap="100">
                  {(isProductDeleted && (lineItemName || "")) || (
                    <Link onClick={() => navigate(productURL)}>{title || ""}</Link>
                  )}
                  <Text as="span" variant="bodySm" color={constant.SUBDUED}>
                    {vendor && vendorId && `${cms("label.vendor")}: ${vendor}`}
                  </Text>
                  <LineItemProperties
                    variation={constant.SUBDUED}
                    properties={properties}
                    isServiceLineItem={isServiceLineItem}
                  />
                  {isServiceLineItem
                    ? ""
                    : sku && (
                      <Text as="span" variant="bodySm" color={constant.SUBDUED}>
                        {cms("label.skuList")}
                        {sku}
                      </Text>
                    )}
                  <Badge tone="critical" className="text-capitalize">
                    {status}
                  </Badge>
                </BlockStack>
              </InlineStack>

              <InlineStack gap="400">
                <Text as="span">{` ${cms("label.qty")}: ${totalQuantity}`}</Text>
                <Text as="span">
                  {moneyFormat}
                  {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
                </Text>
              </InlineStack>
            </InlineStack>
          </Box>
        </div>
      );
    });

  const moneyFormat = data && data.moneyFormat;
  const totalFulfill = (
    <>
      <Divider />
      <Box padding="400">
        <InlineStack align="space-between">
          <Text as="span" fontWeight="semibold">
            {cms("label.total")}
          </Text>
          <InlineStack gap="400">
            <Text variant="bodySm" as="p">
              {" "}
              (
              {countItems > 1
                ? `${countItems}
                ${cms("label.items")} from ${addVendorTxt}`
                : `${countItems}
                ${cms("label.item")} from ${addVendorTxt}`}
              )
            </Text>
            <Text as="span" fontWeight="semibold">
              {`${moneyFormat || constant.symbol.DOLLAR}${totalAmount.toFixed(2)}`}
            </Text>
          </InlineStack>
        </InlineStack>
      </Box>
    </>
  );

  return [lineItems, totalFulfill];
};

export default RejectedLineItems;
